import {
  Armchair, CircleHelp, Construction, Droplet, Flame, Leaf, Lightbulb, MapPin, Recycle, Route, Siren, Snowflake,
  TrafficCone, Trees, Zap, type LucideIcon,
} from 'lucide-react';
import { cn } from '../lib/cn.js';

/** Icônes du catalogue (champ iconName des catégories et des redirections). */
const ICONS: Record<string, LucideIcon> = {
  construction: Construction,
  'traffic-cone': TrafficCone,
  snowflake: Snowflake,
  lightbulb: Lightbulb,
  droplet: Droplet,
  recycle: Recycle,
  leaf: Leaf,
  trees: Trees,
  armchair: Armchair,
  zap: Zap,
  'circle-help': CircleHelp,
  siren: Siren,
  flame: Flame,
  route: Route,
};

export const CATEGORY_ICON_NAMES = Object.keys(ICONS);

/** Composant d'icône d'une catégorie, épingle par défaut. */
export function categoryIconComponent(iconName?: string | null): LucideIcon {
  return (iconName && ICONS[iconName]) || MapPin;
}

interface CategoryIconProps {
  iconName?: string | null;
  color?: string | null;
  className?: string;
}

export function CategoryIcon({ iconName, color, className }: CategoryIconProps) {
  const Icon = categoryIconComponent(iconName);
  return <Icon className={cn('size-4', className)} style={color ? { color } : undefined} aria-hidden />;
}
